.gq{gap:0.25rem;}